module.exports = __webpack_public_path__ + "static/media/fl_cast_mromeo.adf4a77d.jpg";